<template><!-- 广告位 -->
<div class="padding30 box-row borderb" v-if="data">
    <a :href="data.clickUrl" v-if="theme==2" :data-scp="$options.name+'.00'">
        <div class="span6">
            <p style="word-wrap:break-word">{{data.title}}</p>
        </div>
        <div class="span6">
            <img :src="data.imageUrl" alt="" class="border-radius">
        </div>
    </a>
    <a :href="data.clickUrl" v-else :data-scp="$options.name+'.01'">
        <img :src="data.imageUrl" alt="" class="border-radius marginb20">
        <p class="text-darker" style="font-weight: bold;line-height:22px;word-wrap:break-word">{{data.title}}</p>
    </a>
</div>
</template>

<script>
export default {
    props:{
        data:{
            type:Object,
            default:null
        }
        , theme: {
        	type: Number
            , default: 1
        }
    }
}
</script>

<style lang="scss">

</style>